import React, { useEffect, useState } from 'react';
import { useFlamecoAuth } from '../../flameco/FlamecoAuthProvider';
import { StateScreen } from '../../flameco-ui';

// Signed-in only. Signed-out people go straight to the Flameco login page
// (auth.flameco.com; silently first, so a session from another Flameco app
// signs them in without a click) and come back to the page they asked for.
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { ready, user, signIn } = useFlamecoAuth();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (ready && !user && !failed) signIn().catch(() => setFailed(true));
  }, [ready, user, failed, signIn]);

  if (!ready) return null;
  if (user) return <>{children}</>;
  if (failed) {
    return (
      <StateScreen
        title="Sign-in could not start"
        text="Check your connection, then try again."
        actions={
          <button type="button" className="fl-btn fl-btn--primary" onClick={() => setFailed(false)}>
            Try again
          </button>
        }
      />
    );
  }
  return <StateScreen title="Signing you in…" busy />;
};

export default ProtectedRoute;
